export const forTrack = (track) => {
    let samples = [];
    if (track.tracks && Array.isArray(track.tracks)) {
        samples = [... samples,
                   ... track.tracks.map(
                       x => forTrack(x.track))
                  ];
    }
    if (track.samplers) {
        samples = [... samples, ... Object.keys(track.samplers)];
    }
    if (track.instrument && track.instrument.getSamples) {
        let _samples = track.instrument.getSamples().map(
            x => x.getId());
        samples = [... samples, ..._samples];
    }
    
    if (track.frozenColumns) {
        for (let col of track.frozenColumns) {
            samples = [... samples, ...col.frozenSamples.map(x => x.getId())];
        }
    }
    
    for (let effect of track.effects) {
        // are any of these convolver
        if (effect.name === "Convolver Reverb") {
            samples.push(effect.convolverSample);
        }
    }
    return samples;
};
export const  getSamples = async (engine) => {

    let samples = [];
    for (let sub of engine.subSequences) {
        // go thru aach track

        for (let track of sub.tracks) {
            samples = [... samples, ...forTrack(track)];
       }
    }

    samples = [... samples, ... forTrack(engine.metronome)];

    for (let send of engine.sends.sends) {
        for (let effect of send.effects) {
            if (effect.name === "Convolver Reverb") {
                //if (effect.renderedBuffer) {
                 //   samples.push(await effect.getBouncedSample());
                //} else {
                    samples.push(effect.convolverSample);
               // }
            }
        }
    }

    for (let effect of engine.channelMixer.masterChannel.effectsChain.effects) {
        if (effect.name === "Convolver Reverb") {
            //if (effect.renderedBuffer) {
             //   samples.push(await effect.getBouncedSample());
            //} else {
                samples.push(effect.convolverSample);
           // }
        }
    }

    return samples;
};

export const bounceConvolvers = async (engine) => {
   for (let send of engine.sends.sends) {
        for (let effect of send.effects) {
            if (effect.name === "Convolver Reverb") {
                let x = await effect.getBouncedSample();
                effect.convolverSample = x;
            }
        }
    }

    for (let effect of engine.channelMixer.masterChannel.effectsChain.effects) {
        if (effect.name === "Convolver Reverb") {
            let x = await effect.getBouncedSample();
            effect.convolverSample = x;
        }
    }

};

const metadataForTrack = (track) => {
    let samples = [];
    if (track.tracks) {
        return track.tracks.flatMap(
            x => metadataForTrack(x));
    }

    if (track.samplers) {
        for (let id in track.samplers) {
            samples.push(track.samplers[id].sample);
        }
    }
    if (track.instrument && track.instrument.getSamples) {
        let _samples = track.instrument.getSamples();
        samples = [... samples, ..._samples];
    }
    return samples;
};

export const getMetadataForSamples = (engine) => {
    let samples = [];
    for (let sub of engine.subSequences) {
        // go thru aach track
        
        for (let track of sub.tracks) {
            samples = [...samples, ...metadataForTrack(track)];
       }
    }
    let idToSample = {};
    samples.forEach(s => idToSample[s.getId()] = s.getJson());
    return idToSample;
};

export const perTrack = (engine) => {
    let samples = {};
    for (let sub of engine.subSequences) {
        // go thru aach track
        
        for (let track of sub.tracks) {
            samples[track.id] = metadataForTrack(track);
       }
    }
    return samples;
};


export const getPhotos = (engine) => {
    return engine.subSequences.flatMap(sub => getPhotosHelp(sub));
};

const getPhotosHelp = (sub) => {
    let loaders = sub.zObjects.filter(x => x.name === "three.textureLoader");
    let imageHashes = loaders.map(x => x.effect.imageHash).filter(x => x);

    for (let obj of sub.zObjects) {
        if (obj.name === "subpatch") {
            imageHashes = [... imageHashes, ... getPhotosHelp(obj.effect)];
        }
    }
    return imageHashes;
};
